import { Box, Stack, useTheme } from '@mui/material';
import SeeMore from '@/components/SeeMore';
import useResponsive from '@/hooks/useResponsive';
import Typography from '@/components/Typography';
import seoContent from '../../../public/json/shitcoin/seoContent.json';

const SeoContent = () => {
  const { matches } = useResponsive();
  const theme = useTheme();

  const data = seoContent;

  return (
    <Box
      mb={matches({ xs: 21, lg: 23 })}
      mt={{ lg: 6, xs: 6 }}
      sx={{ height: '100%' }}
    >
      <SeeMore
        minHeight="310px"
        buttonProps={{
          variant: 'contained',
          fullWidth: matches({ xs: true, lg: false })
        }}
        linearGradient="linear-gradient(180deg, #181a1f8f 100%, #181A1F 100%)"
        showMoreText="مشاهده بیشتر"
        showLessText="مشاهده کمتر"
      >
        <Stack
          gap={4}
          sx={{
            '& p': {
              pb: 7,
              color: theme.palette.textColor.A30,
              fontSize: '16px',
              textAlign: 'start'
            },
            '& img': {
              display: 'block',
              margin: 'auto'
            },
            '& h4, & h2, & h3,& h5,& h6,& h1,': {
              pb: 3,
              fontSize: matches({ xs: '20px', lg: '22px' }),
              color: theme.palette.textColor.A30,
              fontWeight: 600,
              textAlign: matches({ xs: 'center', lg: 'start' })
            },
            '& a': {
              textDecoration: 'none',
              color: theme.palette.primary.main
            }
          }}
        >
          <Typography
            component="div"
            dangerouslySetInnerHTML={{ __html: data.description }}
          />
        </Stack>
      </SeeMore>
    </Box>
  );
};

export default SeoContent;
